import $ from 'jquery';

export default function resetForm(form) {
  const $form = form;

  if (!$form.length) return;

  $form[0].reset();

  $form.find('input[type="radio"]').each(function () {
    const name = $(this).attr('name');

    $form.find(`input[name="${name}"]`).prop('checked', false);

    const $defaultRadio = $form.find(`input[name="${name}"]`).filter(function () {
      return this.defaultChecked;
    });

    $defaultRadio.prop('checked', true).trigger('change');
  });

  $form.find('select').each(function () {
    const isMultiple = $(this).prop('multiple');

    if (isMultiple) {
      $(this).val([]).trigger('change');
    } else {
      $(this).val('').trigger('change');
    }

    $(this).removeClass('error');
    $form.find('label.error').remove();
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/utils/reset-form.js